let optionPriorityOrder = window.expansive_product_option_value_sort_order ? window.expansive_product_option_value_sort_order : {};

const choicesInstances = {};

window.onload = async () => {
	const product = window.Shopify.currentProduct;

	if (!product) {
		return;
	}

	try {

		const addToCartButton = document.querySelector('form.product-form-main button[name="add"]');
		const addToCartButtonLabel = addToCartButton.querySelector('.button-label');
		addToCartButton.setAttribute('disabled', true);

		const variantMessageEl = document.querySelector('.variant-message');

		const productSelectInputs = document.querySelectorAll('.product-quantity input[type="number"]');
		const quantitySelectControlBtns = document.querySelectorAll('.product-quantity .button');

		let variantInventoryPolicyMap = {};

		/**
		 * Get all the possible purchaseable options for this product, including the selectable attributes to make the controls around
		 */
		const request = await fetch(apiURL, {
			method: 'POST',
			headers: {
				'Content-type': 'application/json',
				'X-Shopify-Storefront-Access-Token': 'e8b2af087be3a07177601422069b1e86'
			},
			body: JSON.stringify({
				query: graphQuery,
				variables: {
					id: `gid://shopify/Product/${window.Shopify.currentProduct.id}`,
				},
			}),
		});

		const result = await request.json();
		let options = [];
		var selected = [];
		const idInput = document.querySelector('form.product-form-main input[type="hidden"][name="id"]');

		let hasAvailableVariants = false;

		// spread the various sub-products and their variants into one flat array
		for (const row of result.data.product.sub_product_group.reference.products.references.nodes) {

			if (row.availableForSale) hasAvailableVariants = true;

			if (row.variantInventoryPolicyMap && row.variantInventoryPolicyMap.value) {
				variantInventoryPolicyMap = { ...variantInventoryPolicyMap, ...JSON.parse(row.variantInventoryPolicyMap.value) };
			}

			options.push(...row.variants.nodes);
		}

		if (!hasAvailableVariants) {
			addToCartButtonLabel.innerText = label_sold_out; //defined in theme.liquid
		}

		/**
		 * Scans through the available options and returns a valid list of options for a single attribute, given the current selection
		 * @param {number} optionIndex the index of the option we're looking to populate
		 * @param {array} selected flat array of currently selected values to filter based on
		 * @returns
		 */
		const enumerateOptions = async (optionIndex = 0, optionLabel) => {
			let output = [];
			let optionsSet = new Set();  // Track added option values

			variantLoop: for (let variant of options) {
				let variantOptionValues = variant.title.split('|').map(t => t.trim());

				// Skip invalidated variants by previous selections & missing option value as before
				if (selected.length) {
					let index = 0;
					for (selectedValue of selected) {
						if (variantOptionValues[index++] !== selectedValue && index <= optionIndex) {
							continue variantLoop;
						}
					}
				}
				
				if (!variantOptionValues[optionIndex]) continue;

				const optionValue = variantOptionValues[optionIndex];
				if (!optionsSet.has(optionValue)) {
					output.push({
						value: optionValue
					});
					optionsSet.add(optionValue);
				}
			}

			let lcOptLabel = typeof optionLabel == 'string' ? optionLabel.toLowerCase() : '';

			if (typeof optionPriorityOrder[lcOptLabel] != 'undefined') {

				output.sort((a, b) => {

					const aIndex = optionPriorityOrder[lcOptLabel].indexOf(a.value.toLowerCase());
					const bIndex = optionPriorityOrder[lcOptLabel].indexOf(b.value.toLowerCase());

					if (aIndex < bIndex) {
						return -1;
					} else if (aIndex > bIndex) {
						return 1;
					}

					return 0;
				});

			} else {
				output.sort();
			}

			return output;
		};

		const shouldOptionValueBeDisabled = (optionValue) => {
			
			const titleSearchStr = [ ...selected, optionValue ].join(" | ");

			const firstAvailableVariantMatch = options.find(v => {		
				
				if (!v.title.includes(titleSearchStr)) return false;

				return v.availableForSale;
			});

			return !firstAvailableVariantMatch;
		}

		const createOptionElements = async (options, select, optionLabel = '') => {
			// clear any old options, then add back in a default one
			select.innerHTML = '';
			// console.log('options', options)
			// console.log('select', select);
			let defaultOptionEl = document.createElement('option');
			defaultOptionEl.innerHTML = label_choose + ' ' + optionLabel;
			defaultOptionEl.value = '';
			select.append(defaultOptionEl);

			// loop through adding new options
			for (let option of options) {
				let optionEl = document.createElement('option');
				optionEl.value = option.value;
				optionEl.innerHTML = option.value;
				optionEl.disabled = shouldOptionValueBeDisabled(option.value); //TODO Check if no available options are avail
				select.append(optionEl);
			}

			select.value = "";

			if (choicesInstances[select.name]) {
				choicesInstances[select.name].refresh(true, true);
			}

		};

		/**
		 * Create the select fields and groups for selecting a variant
		 */
		let selectableOptions = JSON.parse(result.data.product.sub_product_group.reference.options.value);
		const selectTemplate = document.getElementById('sub_product_option');
		const subProductSelectors = document.getElementById('sub_products');

		//console.log(selectableOptions);

		for (let option of selectableOptions) {

			const optionKey = option.replace(' ', '_').toLowerCase();
			const clone = selectTemplate.content.cloneNode(true);
			const label = clone.querySelector('label');
			const select = clone.querySelector('select');

			label.innerHTML = option;
			label.setAttribute('for', optionKey);
			select.setAttribute('name', optionKey);
			select.setAttribute('id', optionKey);

			subProductSelectors.appendChild(clone);
		}


		/**
		 * Populate the first select field with a full, unfiltered list of options
		 */
		createOptionElements(await enumerateOptions(), subProductSelectors.querySelector('.sub_products__option-wrap:first-of-type select'), selectableOptions[0]);

		/**
		 * Add event listeners for the selects to display the next set of options if available
		 */
		const optionSelects = document.querySelectorAll('.sub_products__option-selector');

		optionSelects.forEach((select, index) => {


			select.addEventListener('change', async e => {
				selected[index] = select.value;

				if (variantMessageEl) {
					variantMessageEl.classList.add('hidden');
					variantMessageEl.children[0].innerText = "";
				}

                addToCartButton.disabled = true;
				handleFauxKlaviyoButtonVisbility(false);

				if (optionSelects[index + 1]) {
					let optLabel = selectableOptions[index + 1];
					createOptionElements(await enumerateOptions(index + 1, optLabel), optionSelects[index + 1], optLabel);
				} else {
					const foundVariant = options
						.filter(variant => {
							let i = 0;
							// if the title of this product matches all selected options, it's our one
							for (v of variant.title.split('|').map(t => t.trim())) {
								if (v !== selected[i++]) {
									return false;
								}
							}
							return true;
						})
						?.pop();

					if (!foundVariant) return;

					let quantityFieldEl = document.getElementById('quantity');
					let quantity = quantityFieldEl ? parseInt(quantityFieldEl.value) : 1;

					if (isNaN(quantity)) quantity = 1;

					renderPrice(foundVariant.price.amount, quantity);

					if (!foundVariant.availableForSale) {

						for (const btn of quantitySelectControlBtns) {
							btn.disabled = true;
						}

						addToCartButtonLabel.innerText = label_sold_out; //defined in theme.liquid

						return;
					};

					for (const btn of quantitySelectControlBtns) {
						btn.disabled = false;
					}

					addToCartButtonLabel.innerText = label_add_to_cart; //defined in theme.liquid

					if (typeof variantInventoryPolicyMap[foundVariant.id] == 'string' && variantInventoryPolicyMap[foundVariant.id] == "CONTINUE") {
						for (const input of productSelectInputs) {
							input.max = 999;
						}

                        console.log(foundVariant);

						window.cake_sub_products_found_variant = foundVariant;

                        if (foundVariant.currentlyNotInStock && foundVariant.leadTimeMessage && foundVariant.leadTimeMessage.value && variantMessageEl) {
                            variantMessageEl.classList.remove('hidden');
                            variantMessageEl.children[0].innerText = foundVariant.leadTimeMessage.value;
                        }
						handleFauxKlaviyoButtonVisbility(true);
                    } else {
                        for (const input of productSelectInputs) {
                            input.max = foundVariant.quantityAvailable;
                        }
                    }
                    addToCartButton.disabled = false;

					idInput.value = foundVariant.id.split('/').pop();
				}
			});

			const choicesInstance = new Choices(select, {
				searchEnabled: false,
				shouldSort: false,
				itemSelectText: '',
				callbackOnCreateTemplates: function (template) {
					return {
						choice: (classNames, data) => {
							const soldOutClass = data.element && data.element.classList.contains('sold-out') ? ' sold-out' : '';
							const classes = `choices__item choices__item--choice choices__item--selectable ${soldOutClass}`;

							return template(`
								<div class="${classes}" data-select-text="${this.config.itemSelectText}" data-choice ${data.disabled ? 'data-choice-disabled aria-disabled="true"' : 'data-choice-selectable'} data-id="${data.id}" data-value="${data.value}" ${data.groupId > 0 ? 'role="treeitem"' : 'role="option"'}>
									${data.label}
								</div>
							`);
						}
					};
				}
			});

			choicesInstances[select.name] = choicesInstance;
		}
		);
	} catch (e) {
		console.error(e);
	}
};

const renderPrice = (price, quantity) => {

	let priceSubDivisionValue = parseFloat(price) * 100;

	const priceDisplayEls = document.querySelectorAll('.price, .button-price');

	priceDisplayEls.forEach((el, index) => {

		el.innerHTML = Shopify.formatMoney(priceSubDivisionValue * quantity, Shopify.money_format);

		if (el.dataset.price) {
			el.dataset.price = priceSubDivisionValue;
		}

	});

	const priceDataAttrEls = document.querySelectorAll('[data-price]');

	priceDataAttrEls.forEach((el, index) => {
		if (el.dataset.price) {
			el.dataset.price = priceSubDivisionValue;
		}
	});
};

const apiURL = `https://${window.Shopify.shop}/api/2024-01/graphql.json`;

const graphQuery = `
query($id: ID!){
    product(id: $id) {
        id
        title
        sub_product_group: metafield(namespace: "custom", key: "sub_product_group") {
            reference {
                ... on Metaobject {
                    id
                    options: field(key: "options") {
                        value
                    }
                    products: field(key: "products") {
                        references(first: 50) {
                            nodes {
                                ... on Product {
                                    availableForSale
                                    variantInventoryPolicyMap: metafield(namespace: "cake", key: "variant_inventory_policy_map") {
                                        value
                                    }
                                    variants(first: 100) {
                                        nodes {
                                            id
                                            title
                                            sku
                                            availableForSale
                                            currentlyNotInStock
                                            quantityAvailable
                                            leadTimeMessage: metafield(namespace: "cake", key: "lead_time") {
                                                value
                                            }
                                            price {
                                                amount
                                                currencyCode
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
`;
